<template>
  <div class="pc-layout">
    <div class="custom-nav-bar">
      
    </div>
    <div class="content">
      <router-view />
    </div>
    <div class="footer">
      <p>© 2025 以太坊钱包</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PCLayout'
};
</script>

<style lang="less" scoped>
.custom-nav-bar{
    height: 60px;
    position: fixed;
    z-index: 29090;
}
.pc-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.header {
  background: #2c3e50;
  color: white;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nav a {
  color: white;
  margin-left: 20px;
  text-decoration: none;
}
.content {
  flex: 1;
  padding: 20px;
}
.footer {
  background: #2c3e50;
  color: white;
  text-align: center;
  padding: 10px;
}
</style>
